/**
 * Testi italiani della barra in alto del guscio (ADR 0030 §2.2): messaggio
 * rapido al relay, ricerca globale, notifiche e menu utente. Panoramica e
 * Cronologia hanno i loro file (`overview.ts`, `history.ts`).
 *
 * Stanno fuori da `app.ts` per il limite di lunghezza dei file: il guscio è
 * cresciuto con la barra in alto, e un solo file supererebbe le 500 righe.
 */

/** Testi della barra in alto. */
export const shell = {
  /** Messaggio rapido al relay, dalla barra in alto. */
  quickMessage: {
    /** Pulsante che apre la finestra. */
    open: 'Scrivi all’Institore',
    /** Titolo della finestra. */
    title: 'Messaggio all’Institore',
    /** Nome accessibile del modulo. */
    form: 'Messaggio rapido all’Institore',
    /** Etichetta del selettore del set. */
    set: 'Set',
    /** Etichetta del campo del testo. */
    text: 'Messaggio',
    /** Pulsante di invio. */
    send: 'Invia e apri',
    /** Errore: nessun set scelto. */
    noSet: 'Scegli il set a cui scrivere.',
    /** Errore: testo vuoto. */
    empty: 'Scrivi il messaggio prima di inviarlo.',
    /** Errore: testo oltre il limite. */
    tooLong: 'Il messaggio supera 32 KiB. Accorcialo o dividilo in più messaggi.',
    /** Invio non riuscito. */
    failed: 'Invio non riuscito. Riprova.',
    /** Esito dell'invio. */
    sent: 'Messaggio inviato all’Institore di {{name}}.',
  },

  /** Ricerca globale. */
  search: {
    /** Nome accessibile del campo. */
    label: 'Cerca set e progetti',
    /** Segnaposto del campo. */
    placeholder: 'Cerca set e progetti (Ctrl+K)',
    /** Gruppo dei task del set corrente. */
    tasks: 'Task di {{name}}',
    /** Gruppo dei set nei suggerimenti. */
    sets: 'Set',
    /** Gruppo dei progetti nei suggerimenti. */
    projects: 'Progetti',
    /** Gruppo delle azioni nei suggerimenti. */
    actions: 'Azioni',
    /** Suggerimento che cerca il testo nei task del set corrente. */
    inTasks: 'Cerca «{{q}}» nei task di {{name}}',
    /** Nessun risultato. */
    empty: 'Nessun set o progetto trovato.',
  },

  /** Campanella delle notifiche, alimentata da ciò che chiede un intervento. */
  notifications: {
    /** Nome accessibile del pulsante, con il numero delle novità. */
    label_one: 'Notifiche, {{count}} da fare',
    /** Nome accessibile del pulsante, con il numero delle novità. */
    label_other: 'Notifiche, {{count}} da fare',
    /** Nome accessibile del pulsante senza novità. */
    labelNone: 'Notifiche, niente di nuovo',
    /** Titolo del pannello. */
    title: 'Da fare',
    /** Segna tutto come visto. */
    markSeen: 'Segna come visto',
    /** Esito di «Segna come visto». */
    allSeen: 'Hai visto tutto. Le voci restano finché non le risolvi.',
    /** Voce già vista. */
    seen: 'vista',
    /** Collegamento alla Panoramica. */
    overview: 'Apri la Panoramica',
    /** Nessuna notifica. */
    empty: 'Niente da fare adesso.',
    /** Proposte di task da approvare. */
    proposals_one: '{{count}} proposta di task da approvare',
    /** Proposte di task da approvare. */
    proposals_other: '{{count}} proposte di task da approvare',
    /** Analisi da approvare. */
    analyses_one: "{{count}} analisi di un progetto da approvare",
    /** Analisi da approvare. */
    analyses_other: '{{count}} analisi di progetti da approvare',
    /** Runtime in errore. */
    runtimeFailed: 'Il set è in errore',
    /** Credenziale mancante. */
    credentialMissing: 'Manca la credenziale di Claude',
    /** Pausa per il limite del piano. */
    pausedForLimit: 'In pausa per il limite del piano',
  },

  /** Menu utente. */
  userMenu: {
    /** Riga con ruolo e piano. */
    summary: '{{role}}, {{plan}}',
    /** Voce del profilo. */
    profile: 'Profilo e sicurezza',
    /** Voce delle impostazioni. */
    settings: 'Impostazioni',
    /** Testo per lettori di schermo accanto al punto esclamativo giallo. */
    mfaReminder: 'Verifica in due passaggi da attivare',
    /** Gruppo del tema. */
    theme: 'Tema',
    /** Gruppo della lingua. */
    language: 'Lingua',
    /** Uscita. */
    logout: 'Esci',
  },

  /** Ruoli globali in italiano, al posto dei nomi tecnici. */
  roles: {
    /** Amministratore della piattaforma. */
    ADMIN: 'Amministratore',
    /** Amministratore di progetti. */
    PROJECT_ADMIN: 'Amministratore di progetti',
    /** Utente. */
    USER: 'Utente',
    /** Nessun ruolo. */
    none: 'Nessun ruolo',
  },
};

/** Forma dei testi della barra in alto, usata per tipare le altre lingue. */
export type Shell = typeof shell;
